import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post,remove } from "../../../_helper/api_helper";
import { toast } from "react-toastify";
import { ShowSucess } from "../../../_helper/helper";
import _ from 'lodash';

const sliceName = "employeeDeductionPlan";

export const createOrUpdateEmployeeDeductionPlanMaster = createAsyncThunk(
    "createOrUpdateEmployeeDeductionPlanMaster",
    async (payload) => {
        try {
            let response = await post(`${process.env.REACT_APP_API_DOTNET_URL}/EmployeeDeductionPlan/CreateOrUpdate`, payload);
            if (response?.status == 208) {
                toast.error(`This employee has already this plan`);
            } else {
                toast.success(`${(payload?.id || payload?.Id) ? 'Updated' : 'Created'} successfully`);
            }
            return { createResult: response?.data };
        } catch (error) {
            toast.error(`Something went wrong!. Please try again later.`);
            console.log({ error });
            return { error }
        }
    }
);

export const getEmployeeDeductionPlanById = createAsyncThunk(
    'getEmployeeDeductionPlanById',
    async (id) => {
        try {
            let response = await get(`${process.env.REACT_APP_API_URL_PR}EmployeeDeductionPlanMaster/GetById?Id=${id}`);
            return { data: response.data };
        } catch (error) {
            return { error }
        }
    }
);

export const getEmployeeDeductionPlanByEmployeeIdAndDeductionCode = createAsyncThunk(
    'getEmployeeDeductionPlanByEmployeeIdAndDeductionCode',
    async (obj) => {
        try {
            // let response = await get(`${process.env.REACT_APP_API_URL_PR}Payroll/GetEmployeeDeductionDetail?empId=${obj?.empId}&deductionCode=${obj?.deductionCode}`);
            // let response = await get(`https://localhost:7092/api/Payroll/GetEmployeeDeductionDetail?empId=${obj?.empId}&deductionCode=${obj?.deductionCode}`);

            let response = await post(`${process.env.REACT_APP_API_URL_PR.replace("/api", "")}AdvanceSearch/GetRecords`, obj);
            // if (response?.status == 208) {
            //     toast.error(`This employee has already this plan`);
            // } else {
            //     toast.success(`${payload?.id ? 'Updated' : 'Created'} successfully`);
            // }
            // return { createResult: response?.results };

            return { data: response?.results };
        } catch (error) {
            return { error }
        }
    }
);

export const getDeductionPlanDocuments = createAsyncThunk(
    'getDeductionPlanDocuments',
    async (obj) => {
        try {
            let response = await post(`${process.env.REACT_APP_API_URL_PR.replace("/api", "")}AdvanceSearch/Global?pageNumber=${obj?.pageNumber}&pageSize=${obj?.pageSize}`, obj);
            return { data: response };
        } catch (error) {
            return { error }
        }
    }
);
export const deleteEmployeeDeductionPlan = createAsyncThunk(
    'deleteEmployeeDeductionPlan',
    async (id) => {
        try {
            let response = await remove(`${process.env.REACT_APP_API_URL_PR}EmployeeDeductionPlanMaster/Delete?Id=${id}`);
            ShowSucess(response?.data?.message, { position: "top-right" });
            return { deleteEmployeeDeduction: response };

        } catch (error) {
            return { error }
        }
    }
);
export const getPayrollEmployeeDeduction = createAsyncThunk(
    'getPayrollEmployeeDeduction',
    async (obj) => {
        try {
            // let response = await get(`${process.env.REACT_APP_API_URL_PR}Payroll/GetEmployeeDeductionDetail?empId=${obj?.empId}&deductionCode=${obj?.deductionCode}`);
            // let response = await get(`https://localhost:7092/api/Payroll/GetEmployeeDeductionDetail?empId=${obj?.empId}&deductionCode=${obj?.deductionCode}`);

            let response = await post(`${process.env.REACT_APP_API_URL_PR.replace("/api", "")}AdvanceSearch/GetRecords`, obj);

            return { data: response?.results };
        } catch (error) {
            return { error }
        }
    }
);

export const getAllPayPeriod = createAsyncThunk(
    'getAllPayPeriod',
    async (obj) => {
        try {
            let response = await get(`${process.env.REACT_APP_API_URL_PR}Payroll/GetPayPeriod`);
            // let response = await get(`https://localhost:7092/api/Payroll/GetPayPeriod`);

            // let response = await post(`${process.env.REACT_APP_API_URL_PR.replace("/api", "")}Payroll/GetPayPeriod`, obj);
            // if (response?.status == 208) {
            //     toast.error(`This employee has already this plan`);
            // } else {
            //     toast.success(`${payload?.id ? 'Updated' : 'Created'} successfully`);
            // }
            // return { createResult: response?.results };

            return { data: response?.data };
        } catch (error) {
            return { error }
        }
    }
);

export const resetDeductionCreateReset = createAsyncThunk('resetDeductionCreateReset', async () => {
    return {}
});

export const resetEmployeeDeductionPlan = createAsyncThunk('resetEmployeeDeductionPlan', async () => {
    return {}
});

const employeeDeductionsPlanlice = createSlice({
    name: sliceName,
    initialState: {
        createResult: {},
        isCreating: false,
        deleteEmployeeDeduction: null,
        isDeleting: false,
        createError: {},
        deleteError: {},
        isFetching: false,
        employeeDeductionPlan: {},
        error: {},
        actualDeductionPlanList: [],
        isDeductionLoading: false,
        searchResults: [],
        loadingSearch: false,
        payPeriodList: [],
        isPayPeriodLoading: false,
        allEmployeeDeductionPlanMasterList: [],
        isEmployeeDeductionLoading: false,
        deductionDocuments: [],
        isDocumentLoading: false
    },
    extraReducers: (builder) => {
        builder
            .addCase(createOrUpdateEmployeeDeductionPlanMaster.pending, (state) => { state.isCreating = true; })
            .addCase(createOrUpdateEmployeeDeductionPlanMaster.fulfilled, (state, action) => {
            console.log('Reducer fulfilled action payload:', action.payload); // Log fulfilled action payload

                state.createResult = action.payload?.createResult;
                state.isCreating = false;
            })
            .addCase(createOrUpdateEmployeeDeductionPlanMaster.rejected, (state, action) => {
                state.createResult = {};
                state.createError = action.payload?.error;
                state.isCreating = false;
            }).addCase(deleteEmployeeDeductionPlan.pending, (state) => { state.isDeleting = true; })
            .addCase(deleteEmployeeDeductionPlan.fulfilled, (state, action) => {
                state.deleteEmployeeDeduction = action.payload?.deleteEmployeeDeduction;
                state.isDeleting = false;
            })
            .addCase(deleteEmployeeDeductionPlan.rejected, (state, action) => {
                state.deleteEmployeeDeduction = null;
                state.deleteError = action.payload?.error;

                state.isDeleting = false;
            })
            .addCase(getEmployeeDeductionPlanById.pending, (state) => { state.isFetching = true; })
            .addCase(getEmployeeDeductionPlanById.fulfilled, (state, action) => {
                state.employeeDeductionPlan = action?.payload?.data || {};
                state.isFetching = false;
            })
            .addCase(getEmployeeDeductionPlanById.rejected, (state, action) => {
                state.employeeDeductionPlan = {};
                state.error = action?.payload?.error;
                state.isFetching = false;
            })
            .addCase(getEmployeeDeductionPlanByEmployeeIdAndDeductionCode.pending, (state) => { state.isEmployeeDeductionLoading = true; })
            .addCase(getEmployeeDeductionPlanByEmployeeIdAndDeductionCode.fulfilled, (state, action) => {
                state.allEmployeeDeductionPlanMasterList = action.payload?.data;
                state.isEmployeeDeductionLoading = false;
            })
            .addCase(getEmployeeDeductionPlanByEmployeeIdAndDeductionCode.rejected, (state, action) => {
                state.allEmployeeDeductionPlanMasterList = [];
                state.error = action.payload?.error;
                state.isEmployeeDeductionLoading = false;
            })
            .addCase(getDeductionPlanDocuments.pending, (state) => { state.isDocumentLoading = true; })
            .addCase(getDeductionPlanDocuments.fulfilled, (state, action) => {
                state.deductionDocuments = action.payload?.data;
                state.isDocumentLoading = false;
            })
            .addCase(getDeductionPlanDocuments.rejected, (state, action) => {
                state.deductionDocuments = [];
                state.error = action.payload?.error;
                state.isDocumentLoading = false;
            })
            .addCase(getPayrollEmployeeDeduction.pending, (state) => { state.isDeductionLoading = true; })
            .addCase(getPayrollEmployeeDeduction.fulfilled, (state, action) => {
                state.actualDeductionPlanList = action.payload?.data;
                state.isDeductionLoading = false;
            })
            .addCase(getPayrollEmployeeDeduction.rejected, (state, action) => {
                state.actualDeductionPlanList = [];
                state.error = action.payload?.error;
                state.isDeductionLoading = false;
            })
            .addCase(getAllPayPeriod.pending, (state) => { state.isPayPeriodLoading = true; })
            .addCase(getAllPayPeriod.fulfilled, (state, action) => {
                state.payPeriodList = action.payload?.data;
                state.isPayPeriodLoading = false;
            })
            .addCase(getAllPayPeriod.rejected, (state, action) => {
                state.actualDeductionPlanList = [];
                state.error = action.payload?.error;
                state.isPayPeriodLoading = false;
            })
            .addCase(resetDeductionCreateReset.fulfilled, (state, action) => {
                state.createResult = {};
                state.createError = {};
                state.isCreating = false;
            })
            .addCase(resetEmployeeDeductionPlan.fulfilled, (state, action) => {
                state.employeeDeductionPlan = {};
                state.isFetching = false;
            });
    },
});
export default employeeDeductionsPlanlice.reducer;
